import React, { Component } from 'react';
import './Loader.css';

class Loader extends Component {
  constructor (props) {
    super (props);
  }
  render() {
    return (
      <div className='loader flex flex-row flex-center flex-filler'>
        <span className="segment-spinner"></span>
        { this.props.message && 
        <span className="u__husky u__bold" id="loading-information-text">{this.props.message}</span> }
      </div>
    );
  }
}

export default Loader;



// WEBPACK FOOTER //
// ./src/Components/Loader/Loader.js